import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useReactQueryHelpers } from "shared/hooks/useReactQueryHelpers";
import { RxLookupApiEndpoints } from "../RxLookupConstants";

export function useUnmatchRxLookupClaim() {
  const { oktaAuth } = useOktaAuth();
  const { invalidateReactQueryKey } = useReactQueryHelpers();

  return useMutation({
    mutationFn: async ({ mmid, rxNumber, clid, pyids }) => {
      const accessToken = oktaAuth.getAccessToken();
      const response = await axios.post(
        RxLookupApiEndpoints.UnmatchClaimsAndPayments,
        { mmid, rxNumber, clid, pyids },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return response.data;
    },
    onSuccess: () => {
      // Refresh the Rx Lookup grid (so Adjusted By shows) and the modal data
      invalidateReactQueryKey(RxLookupApiEndpoints.Get);
    },
  });
}
